import {
  Button,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import BackButton from "../../components/BackButton";

export default function Ticket() {
  const { user } = useSelector((state) => state.auth);
  const formik = useFormik({
    initialValues: {
      name: user.name,
      email: user.email,
      subject: "",
      department: "technical",
      related_service: "none",
      priority: "medium",
      message: "",
      attachments: ""
    },
    onSubmit: async (values) => {
      console.log(values);
    }
  });
  return (
    <div
      style={{
        maxWidth: "90%",
        margin: "auto"
      }}
    >
      <BackButton />
      <Card sx={{ p: 2 }}>
        <Typography variant="h3">Submit Ticket</Typography>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField fullWidth {...formik.getFieldProps("name")} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth {...formik.getFieldProps("email")} />
            </Grid>
          </Grid>
          <br />
          <TextField
            fullWidth
            {...formik.getFieldProps("subject")}
            multiline
            rows={2}
            placeholder="Subject"
          />
          <Grid container spacing={2} my={2}>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel id="department-select-label">Department</InputLabel>
                <Select
                  labelId="department-select-label"
                  label="Department"
                  {...formik.getFieldProps("department")}
                >
                  <MenuItem value="technical">Technical</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel id="select-label">Related Service</InputLabel>
                <Select
                  labelId="select-label"
                  label="Related Service"
                  {...formik.getFieldProps("related_service")}
                >
                  <MenuItem value="none">None</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel id="priority-select-label">Priority</InputLabel>
                <Select
                  labelId="priority-select-label"
                  label="Age"
                  {...formik.getFieldProps("priority")}
                >
                  <MenuItem value="high">High</MenuItem>
                  <MenuItem value="medium">Medium</MenuItem>
                  <MenuItem value="low">Low</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <TextField
            fullWidth
            placeholder="Message"
            {...formik.getFieldProps("message")}
            multiline
            rows={12}
          />
          <Stack direction="row" justifyContent="end" mt={2}>
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </Stack>
        </form>
      </Card>
    </div>
  );
}
